<template>
  <div>
    <p v-if="receiptCounts.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">暂无记录</p>
    <ReceiptCountItem
      v-for="item in receiptCounts"
      v-else
      :key="item.companyId"
      :name="item.name"
      :receipt-max="item.receiptMax"
      :normal-receipt-approved="item.normalReceiptApproved"
      :special-receipt-approved="item.specialReceiptApproved"
      :normal-receipt-remaining="item.normalReceiptRemaining"
      :special-receipt-remaining="item.specialReceiptRemaining"/>
  </div>
</template>

<script>
  import ReceiptCountItem from "../../components/ReceiptCountItem";
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "ReceiptCounts",
    components:{
      ReceiptCountItem
    },
    computed:{
      ...mapGetters(['receiptCounts','showLoading'])
    },
    methods:{
      ...mapActions(['getReceiptCounts'])
    },
    created() {
      let params = {
        companyId: this.currentUser.companyId || null
      };
      let role = this.currentUser.role;
      this.getReceiptCounts({role:role,params:params});
    }
  }
</script>

<style scoped>

</style>